$('.js-extend-regular-reservation-modal').click(function(){

    let regular_hash = $(this).data('regular-hash');

    let data_to_send = {
        action: 'extend_regular_reservation_modal',
        regular_hash: regular_hash,
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            response = JSON.parse( response );

            if(response.success){

                let extend_reservation_modal = $('.reservation-extend-modal');

                $('.js-modal-object-title').html(response.object_title);
                $('.js-modal-regular-terms').html(response.regular_terms_html);
                $('.js-modal-time').html( response.service_time );
                $('.js-modal-time-till').text( response.time_till );
                $('.js-modal-service-price').html(response.service_price);
                $('.js-modal-date').html( response.reservation_date);
                if(response.has_parts){
                    $('.js-modal-part').show();
                    $('.js-modal-part-title').html(response.part_title);
                    $('.js-modal-part-text').html(response.part_text);
                }else{
                    $('.js-modal-part').hide();
                }
                $('.js-modal-day-name').html( response.day_name);
                $('.js-modal-service-name').html(response.service_name);

                if(response.shutdown_alert_html){
                    $('.js-alert-shutdown').html(response.shutdown_alert_html).show();
                }else{
                    $('.js-alert-shutdown').hide();
                }

                if(response.hide_regular_alert){
                    $('.js-alert-minimum-4-terms').hide();
                }else{
                    $('.js-alert-minimum-4-terms').show();
                }

                if(response.new_service_name){
                    $('.js-modal-new-service-name').html(response.new_service_name).show();
                    extend_reservation_modal.addClass('changed-service-name');
                }else{
                    $('.js-modal-new-service-name').hide();
                    extend_reservation_modal.removeClass('changed-service-name');
                }

                if(response.new_service_price){
                    $('.js-alert-changed-service-price').show();
                    $('.js-modal-new-service-price-wrapper').show();
                    $('.js-modal-new-service-price').html(response.new_service_price)
                    extend_reservation_modal.addClass('changed-service-price');
                }else{
                    $('.js-alert-changed-service-price').hide();
                    $('.js-modal-new-service-price-wrapper').hide();
                    extend_reservation_modal.removeClass('changed-service-price');
                }

                $('.js-modal-extend-regular-reservation').data('regular-hash', regular_hash);
                $('.regular-terms-controller').data('regular-hash', regular_hash);

                modal_open(extend_reservation_modal);

                if(response.allow_add_to_cart){
                    $('.js-modal-extend-regular-reservation').removeAttr('disabled');
                }else{
                    $('.js-modal-extend-regular-reservation').attr('disabled', 'disabled');
                }

            }else{
                notif(response.notif_type, response.notif);
            }
        }
    })
});

function get_regular_dates_from_modal_list(){
    let extend_dates = [];

    $('.js-available-term span').each(function() {
        extend_dates.push($(this).text().trim());
    });
    return extend_dates;
}

$('.js-modal-extend-regular-reservation').click(function(){
    let regular_hash = $(this).data('regular-hash');

    let extend_dates = get_regular_dates_from_modal_list();

    let data_to_send = {
        action: 'extend_regular_reservation',
        regular_hash: regular_hash,
        extend_dates: extend_dates
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            response = JSON.parse( response );

            if(response.success){
                notif('success', response.notif);
                refresh_header(response.header);
                let extend_modal_button =  $('.js-extend-regular-reservation-modal[data-regular-hash="' + regular_hash + '"]');
                extend_modal_button.text(extend_modal_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
                modal_close();
            }else{
                notif(response.notif_type, response.notif);

                let number_of_terms = $('.js-number-of-regular-terms').val();
                get_table_regular_possible_terms(number_of_terms);
            }
        }
    });
})

$('.js-pay-reservation').click(function(){

    let data_to_send = {
        action: 'pay_reservation',
        reservation_id: $(this).data('reservation-id'),
        regular_hash: $(this).data('regular-hash'),
    }

    let pressed_button = $(this);

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response){
        if(response){
            response = JSON.parse( response );

            if(response.success){
                notif('success', response.notif);
                refresh_header(response.header);
                pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
            }else{
                notif(response.notif_type, response.notif);
            }
        }
    })
})

$('.js-show-all-child-reservations').click(function(){
    let parent = $(this).parent('.child-reservations-wrapper');
    let child_reservations = $('.hidable', parent);
    if($(this).hasClass('active')){
        $('.text', this).text($(this).data('open-text'));
        $('svg', this).removeClass('rotate-180 mt-1');
        $(this).removeClass('active');
        child_reservations.slideUp();
    }else{
        $('.text', this).text($(this).data('close-text'));
        $('svg', this).addClass('rotate-180 mt-1');
        $(this).addClass('active');
        child_reservations.slideDown();
    }
});

$('.js-discontinue-regular-reservation').click(function(){

    if(confirm($(this).data('confirm-text'))) {

        let hash = $(this).data('regular-hash');
        let cancel_button = $(this);
        let data_to_send = {
            action: 'discontinue_regular_reservation',
            regular_hash: hash
        };

        jQuery.post(BASE_URL + '/wp-admin/admin-ajax.php', data_to_send, function (response) {
            if (response) {
                response = JSON.parse(response);

                if (response.success) {
                    notif('warning', response.notif);
                    location.reload(true);
                } else {
                    notif('warning', response.notif);
                }
            }
        })
    }
})

$('.js-send-qr-code').click(function(){
    let button = $(this);
    button.attr('disabled', 'disabled');
    button.html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');

    jQuery.ajax({
        url: BASE_URL + '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'send_qr_code_to_email',
            reservation_id: $(this).data('reservation-id'),
            building_id: $(this).data('building-id'),
        },
        success: function(response) {
            response = JSON.parse( response );

            if (response.success) {
                notif('success', response.notif);
            }else{
                notif('danger', response.notif);
            }

            button.remove();
            //location.reload(true);
        }
    })
})

$('.js-storno-reservation').click(function(){
    if(confirm($(this).data('confirm-text'))) {

        let button = $(this);
        button.attr('disabled', 'disabled');
        button.html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');

        jQuery.ajax({
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'storno_reservation',
                reservation_id: $(this).data('reservation-id'),
                is_admin: 0
            },
            success: function(response) {
                //response = JSON.parse( response );
                button.remove();
                location.reload(true);
            }
        })
    }
})


/*
$('.js-add-all-reservations-to-basket').click(function(){
    $('.js-pay-reservation').click();
    $('.js-extend-regular-reservation-modal').click();
})
*/

function refresh_reservation_list_add_to_cart_buttons(){

    jQuery.ajax({
        url: BASE_URL+'/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'refresh_reservation_list_add_to_cart_buttons',
        },
        success: function(response) {
            response = JSON.parse( response );

            if(response.empty_cart){
                $('.js-pay-reservation').removeClass('btn-warning').addClass('btn-primary').text($('.js-pay-reservation').data('default-text'));
                $('.js-extend-regular-reservation-modal').removeClass('btn-warning').addClass('btn-primary').text($('.js-extend-regular-reservation-modal').data('default-text'));
            }else{

                if(Object.keys(response.in_cart_for_pay).length > 0) {
                    $('.js-pay-reservation').each(function(){
                        if(jQuery.inArray($(this).data('reservation-id'), response.in_cart_for_pay) === -1){
                            $(this).removeClass('btn-warning').addClass('btn-primary').text($(this).data('default-text'));
                        }
                    })
                }

                if(Object.keys(response.in_cart_for_extend).length > 0) {
                    $('.js-extend-regular-reservation-modal').each(function(){
                        if(jQuery.inArray($(this).data('regular-hash'), response.in_cart_for_extend) === -1){
                            $(this).removeClass('btn-warning').addClass('btn-primary').text($(this).data('default-text'));
                        }
                    })
                }
            }
        }
    })
}

$('.js-ended-reservations-show-more').click(function(){
    let table = $('.js-ended-reservations-table');
    let page_limit = table.data('page-limit');
    let reservations_count = table.data('reservations-count');
    let page = table.data('page');
    page = page + 1;

    $('tr', table).slice(0, page * page_limit).slideDown();

    table.data('page', page);

    if(page * page_limit >= reservations_count){
        $(this).hide();
    }
})
